import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Teleport as _Teleport, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-65d2a133"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "navbar-container" };
const _hoisted_2 = { class: "nav_left" };
const _hoisted_3 = /*#__PURE__*/ _createTextVNode(" 禁止挖矿，一经发现后自动删除相关实例，自行承担法律责任。 ");
const _hoisted_4 = { class: "home-box m-l-auto display-flex align-items" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "menu-item" }, "文档中心", -1));
const _hoisted_6 = { class: "message-box" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "label" }, "账号余额：", -1));
const _hoisted_8 = { class: "text" };
import CloudInfo from "@/components/CloudInfo/index.vue";
import CloudNotify from "@/components/CloudNotify/index.vue";
import { useRouterGroup } from "@/hooks/useRouterGroup";
import Area from "@/pages/Area/index.vue";
import { notReadMessage } from "@/service/message";
import { appCounterStore } from "@/store/app";
import { useCounterStore } from "@/store/user";
import { computed, onMounted, onUnmounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import PageHeader from "./Page-Header/index.vue";
export default /*#__PURE__*/ _defineComponent({
    name: 'Navbar',
    setup(__props) {
        const { activeRouterName } = useRouterGroup();
        const router = useRouter();
        const route = useRoute();
        const userStore = useCounterStore();
        const appStore = appCounterStore();
        const userInfo = userStore.getUserInfo;
        const showCost = ref(false);
        const isShow = ref(false);
        let leaveTimer = null;
        const mouseenter = (e) => {
            if (leaveTimer) {
                clearTimeout(leaveTimer);
                leaveTimer = null;
            }
            isShow.value = true;
            updatePosition(e.currentTarget);
        };
        const mouseleave = () => {
            leaveTimer = setTimeout(() => {
                isShow.value = false;
            }, 300);
        };
        const boxStyle = ref({});
        const updatePosition = (target) => {
            const rect = target.getBoundingClientRect();
            boxStyle.value = {
                position: "absolute",
                left: rect.left - 20 + "px",
                top: rect.bottom + "px",
                "z-index": 999
            };
        };
        const handleDropdownEnter = () => {
            // 鼠标进入下拉菜单，取消关闭
            if (leaveTimer) {
                clearTimeout(leaveTimer);
                leaveTimer = null;
            }
        };
        const handleDropdownLeave = () => {
            // 鼠标离开下拉菜单，立即关闭
            isShow.value = false;
        };
        const gofinance = () => {
            router.push({
                path: `/finance/overview`
            });
        };
        const sidebar = computed(() => appStore.sidebar);
        const openDoc = () => {
            window.open(process.env.VUE_APP_DOC_URL);
        };
        const openTutorials = () => {
            window.open(process.env.VUE_APP_TUTORIALS_URL);
        };
        const skillDoc = () => {
            window.open(`${process.env.VUE_APP_DOC_URL}/docs/contact.html`);
        };
        const getUnReadMessageCount = async () => {
            const res = await notReadMessage();
            appStore.setMsgTotal(res.data.total);
        };
        const timer = setInterval(() => {
            if (localStorage.getItem("isRefresh")) {
                appStore.getUnReadMessageCount();
                userStore.fetchBalance();
            }
        }, 6000 * 10);
        const unReadCount = computed(() => appStore.getMsgTotal >= 99 ? "99+" : appStore.getMsgTotal);
        onMounted(async () => {
            userStore.fetchBalance();
            appStore.getUnReadMessageCount();
        });
        onUnmounted(() => {
            clearTimeout(timer);
        });
        const showArea = computed(() => {
            return ((activeRouterName.value === "resource" ||
                activeRouterName.value === "mirrorList" ||
                activeRouterName.value === "application") &&
                ![
                    "objectStorageDetail",
                    "cluster-detail",
                    "ssh-detail",
                    "ssh-event",
                    "virtualMachine-renewal",
                    "virtualMachine-detail"
                ].includes(route.name));
        });
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["navbar", { expand: _unref(sidebar) }])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(PageHeader),
                        (_unref(showArea))
                            ? (_openBlock(), _createBlock(Area, { key: 0 }))
                            : _createCommentVNode("", true),
                        _createVNode(CloudNotify, {
                            class: "flex notify",
                            size: "small"
                        }, {
                            icon: _withCtx(() => [
                                _createVNode(_component_svg_icon, {
                                    "icon-class": "notification",
                                    "class-name": "info-icon"
                                })
                            ]),
                            default: _withCtx(() => [
                                _hoisted_3
                            ]),
                            _: 1
                        })
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        (_unref(userInfo).type === 'master')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "drop-container",
                                onMouseenter: _cache[0] || (_cache[0] = ($event) => (showCost.value = true)),
                                onMouseleave: _cache[1] || (_cache[1] = ($event) => (showCost.value = false))
                            }, null, 32))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", {
                            class: "menu-item",
                            onClick: skillDoc
                        }, "技术支持"),
                        _createElementVNode("div", {
                            class: "info",
                            onMouseenter: mouseenter,
                            onMouseleave: mouseleave
                        }, [
                            _hoisted_5,
                            (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                                (isShow.value)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["info-box drop-transition", { 'drop-border': isShow.value }]),
                                        style: _normalizeStyle(boxStyle.value),
                                        onMouseenter: handleDropdownEnter,
                                        onMouseleave: handleDropdownLeave
                                    }, [
                                        _createElementVNode("div", { class: "bottom-box" }, [
                                            _createElementVNode("div", { onClick: openDoc }, "帮助文档"),
                                            _createElementVNode("div", { onClick: openTutorials }, "技术教程")
                                        ])
                                    ], 38))
                                    : _createCommentVNode("", true)
                            ]))
                        ], 32),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(CloudInfo, {
                                "un-read-count": _unref(unReadCount),
                                onReadMessage: getUnReadMessageCount
                            }, null, 8, ["un-read-count"])
                        ]),
                        (_unref(userInfo).type === 'master')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "money-box",
                                onClick: gofinance
                            }, [
                                _hoisted_7,
                                _createElementVNode("span", _hoisted_8, "¥ " + _toDisplayString(_unref(userStore).balance), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ], 2));
        };
    }
});
